import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { User } from './user';
import { AbstractAuthService } from 'src/app/kc-auth/services';

@Injectable({ providedIn: 'root' })
export class AuthService extends AbstractAuthService<any> {
  loggedInUser = new ReplaySubject<User>(1);

  protected init(): void {
    //TODO Reenable and configure for authenticated access
    /*
    super.init();
    this.session$.subscribe((session) => {
      this.loggedInUser.next(session?.user || null);
      const isOnLandingPage =
        this.router.routerState.snapshot.url === '/landing-page';
      if (session === null) {
        this.router.navigate(['landing-page'], { replaceUrl: true });
      } else if (isOnLandingPage) {
        this.router.navigate(['buddy'], { replaceUrl: true });
      } else {
        this.router.navigate(['buddy'], { replaceUrl: true });
      }
    });*/
  }

  register() {
    console.warn('Registration is disabled.');
  }
}
